import { Table, TableColumnsType } from 'antd'

import { numberFormat } from '../../../../utils'
import { IStockReportProductRow } from './types'

interface Props {
  data: IStockReportProductRow[]
  isLoading?: boolean
}

const signStyle = (value: number) =>
  value > 0
    ? { color: '#389e0d' }
    : value < 0
      ? { color: '#cf1322' }
      : undefined

const StockDeductionProductTable = ({ data, isLoading }: Props) => {
  const columns: TableColumnsType<IStockReportProductRow> = [
    {
      title: 'สินค้า',
      dataIndex: 'productName',
      key: 'productName',
      render: (name: string, row) => (
        <div>
          <div>{name || 'ไม่พบสินค้า'}</div>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>
            รหัสสินค้า: {row.productCode || '-'}
          </div>
        </div>
      ),
    },
    {
      title: 'ตัด (ชิ้น)',
      dataIndex: 'reduceQuantity',
      key: 'reduceQuantity',
      align: 'right',
      sorter: (a, b) => a.reduceQuantity - b.reduceQuantity,
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'คืน (ชิ้น)',
      dataIndex: 'addQuantity',
      key: 'addQuantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'สุทธิ (ชิ้น)',
      dataIndex: 'netQuantity',
      key: 'netQuantity',
      align: 'right',
      render: (value: number) => (
        <span style={signStyle(value)}>{numberFormat(value, 0)}</span>
      ),
    },
    {
      title: 'ต้นทุน/ชิ้น (฿)',
      dataIndex: 'cost',
      key: 'cost',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'มูลค่าต้นทุน (฿)',
      dataIndex: 'netCost',
      key: 'netCost',
      align: 'right',
      sorter: (a, b) => a.netCost - b.netCost,
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'รายการ',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ออเดอร์',
      dataIndex: 'orderCount',
      key: 'orderCount',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
  ]

  return (
    <Table<IStockReportProductRow>
      rowKey={(row) => row.productObjectId || row.productCode || ''}
      columns={columns}
      dataSource={data}
      loading={isLoading}
      size="small"
      pagination={{ pageSize: 20, showSizeChanger: false }}
      locale={{ emptyText: 'ไม่มีการตัดสต๊อกในวันนี้' }}
    />
  )
}

export default StockDeductionProductTable
